import React, { FunctionComponent } from 'react'
import { Transfer } from 'antd'
import type { TransferProps } from 'antd'
import { getAllData } from '../../../../../utils/data'
import { Agencies } from 'server'
import { useQuery } from '@tanstack/react-query'
import { useFeathersClient } from '@strac/react-client-feathers'
import { TransferKey } from 'antd/es/transfer/interface'

interface RecordType {
  key: number
  title: string
  description: string
}

interface IProps {
  targetKeys: number[]
  setTargetKeys: (value: TransferKey[]) => void
  selectedKeys: number[]
  setSelectedKeys: (value: TransferKey[]) => void
}

const AccessManagerTableTransfer: FunctionComponent<any> = (props: IProps) => {

  const { targetKeys, setTargetKeys, selectedKeys, setSelectedKeys } = props

  const client = useFeathersClient()

  const distinctAgencyIdsQuery = {
    key: 'distinctAgencyIds'
  }
  const { data: distinctAgencyIds } = useQuery({
    queryKey: ['knex', 'find', distinctAgencyIdsQuery],
    queryFn: () => client.service('knex').find({
      query: distinctAgencyIdsQuery
    }),
    placeholderData: []
  })

  const agencyIds = distinctAgencyIds.map((agency: any) => agency.agency_id)

  const agenciesQuery = {
    id: {
      $in: agencyIds
    }
  }
  const { data: agencies } = useQuery({
    queryKey: ['agencies', 'find', agenciesQuery],
    queryFn: () => getAllData(client, 'agencies', agenciesQuery),
    placeholderData: []
  })

  const missingAgencyIds = targetKeys
    .filter((agencyId) => !agencies.find((agency: Agencies) => agency.agency_id === agencyId))
    .map((agencyId) => agencyId)

  const missingAgencyQuery = {
    id: {
      $in: missingAgencyIds
    }
  }
  const { data: missingAgencyData } = useQuery({
    queryKey: ['agencies', 'find', missingAgencyQuery],
    queryFn: () => getAllData(client, 'agencies', missingAgencyQuery),
    enabled: !!missingAgencyIds.length,
    placeholderData: []
  })

  const onChange: TransferProps['onChange'] = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys)
  }

  const onSelectChange: TransferProps['onSelectChange'] = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
  }

  const data: RecordType[] = [...agencies, ...missingAgencyData].map((agency: any): RecordType => {
    return {
      key: agency.id,
      title: `${agency.name}`,
      description: `Agency ID: ${agency.id}`
    }
  })

  return (
    <Transfer
      style={{
        flex: 1
      }}
      listStyle={{
        width: '100%',
        height: '60vh',
        minHeight: '500px'
      }}
      showSearch={true}
      dataSource={data}
      titles={['Source', 'Target']}
      targetKeys={targetKeys}
      selectedKeys={selectedKeys}
      onChange={onChange}
      onSelectChange={onSelectChange}
      render={(item: RecordType) => item.title}
    />
  )
}

export default AccessManagerTableTransfer
